import { useGlobalAISocket } from "@/hooks/useGlobalAISocket";
import { useGlobalSocket } from "@/hooks/useGlobalSocket";
import { ConfigProvider } from "antd";
import type { PropsWithChildren } from "react";
import FormItemExplainHandler from "./FormItemExplainHandler";
import ModalProvider from "./modal-provider/ModalProvider";
import QueryClientProvider from "./query-client-provider";
import ThemeProvider from "./theme-provider";

const Providers = ({ children }: PropsWithChildren) => {
  useGlobalSocket();
  useGlobalAISocket();
  return (
    <>
      <QueryClientProvider>
        <ThemeProvider>
          <ConfigProvider>
            <ModalProvider />
            {children}
          </ConfigProvider>
        </ThemeProvider>
      </QueryClientProvider>
      <FormItemExplainHandler />
    </>
  );
};

export default Providers;
